import Vue from 'vue'
import App from './App.vue'
import { router } from './_helpers'
import store from './store/index'
import Buefy from 'buefy'
import VueI18n from 'vue-i18n'
import VeeValidate from 'vee-validate'
import '@mdi/font/css/materialdesignicons.css'
import en from './lang/en'
import jp from './lang/jp'
import './assets/sass/main.scss'
import 'buefy-daterange-picker/dist/buefy-daterange-picker.css'
// setup fake backend
import { configureFetchApi } from './_helpers'
import { localStore } from '@/_utils/localstore'
import { DEFAULT_LOCALE } from '@/_consts/common'
configureFetchApi()

import './registerServiceWorker'

import _ from 'lodash'
import { isTabletSize, isMobileSize, isSafari } from '@/_services/vue.prototype.service'

Object.defineProperty(Vue.prototype, '$_', { value: _ })

Vue.use(Buefy)
Vue.use(VueI18n)
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'vvFields',
})

Vue.config.productionTip = false

// Register custom prototype
Vue.prototype.$isTabletSize = isTabletSize
Vue.prototype.$isMobileSize = isMobileSize
Vue.prototype.$isSafari = isSafari

const messages = {
  'en': en,
  'jp': jp,
}

const i18n = new VueI18n({
  locale: localStore.getItem('lang') || DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages,
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
